import { render, staticRenderFns } from "./Precheckin.vue?vue&type=template&id=12c647db"
import script from "./Precheckin.vue?vue&type=script&lang=js"
export * from "./Precheckin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports